<template>
  <!-- 사용자 예약정보가 있을경우 즉시 신청완료 화면으로 이동 -->
  <!-- 예약정보가 없을때만 아래 템플릿 보여주기 -->
    <div v-if="this.existReservation === 'N'" class="akl"><div class="bod-view-txt">

<div class="os_noticeRes taola_wrap">
  <div class="widM padTM cont_Wrap">
    <div class="txtC padBM" style="border-bottom:1px solid #ddd;">
      <img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png" alt="Amway (로고)" class="icoS" style="max-width:115px;">
    </div>

    <div class="taola_banner">
        <img class="pcOnly" src="../_images/img_banner_pc.png" alt="25cent ride 온 우주가 다타라!! 우주라이드 would u ride? 우주라이드 타올라존 티켓 신청 티켓 신청 기간 8월 3일 (목) ~ 한정수량"/>
        <img class="moOnly" src="../_images/img_banner_mo.png" alt="25cent ride 온 우주가 다타라!! 우주라이드 would u ride? 우주라이드 타올라존 티켓 신청 티켓 신청 기간 8월 3일 (목) ~ 한정수량"/>
    </div>
    <!-- //header -->
    <!-- 참가자 정보 -->
    <div style="background:#f4f4f4; border-top:2px solid #ddd;">
      <div class="widM padTS padBS taola_title">
        <div class="fntH4 bold" style="color:#2c2c2c;">참가자 정보</div>
      </div>
    </div>

    <div class="widM NCACroa_cont01_wrap">
      <div class=" clearfix">
        <div class="NCACroa_cont01-1 padBM padTM NCACroa_cont01_input">
            <span class="fntP bold">이름</span>
            <span class="fntP bold colorRightGray">{{this.aboInfo.user_name}}</span>
          </div>

          <div class="NCACroa_cont01-1 padBM padTM NCACroa_cont01_input">
            <span class="fntP bold">ABO번호</span>
            <span class="fntP bold colorRightGray">{{this.aboInfo.user_id}}</span>
          </div>
      </div>
    </div>

    <!-- 세션 선택 -->
    <div class="marTML mo_marTML1" style="background:#f4f4f4; border-top:2px solid #ddd;">
        <div class="widM padTS padBS taola_title">
          <div class="fntH4 bold" style="color:#2c2c2c;">세션 선택</div>
        </div>
      </div>

    <div class="widM txtC marTM">
        <div class="marBML">
            <div>
              <div class="osResTbScrollWrap" style="border: none; box-shadow: none;">
                <div class="osResTbScroll"> 
                  <img class="pcOnly" src="../_images/timeTable_pc_2.png" alt="">
                  <img class="moOnly" src="../_images/timeTable_mo_2.png" alt="">
                </div>
              </div>
            </div>
          </div>
    </div>
    <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:4.5px 0;">

    <div class="widM">
      <p class="fntH6 fntL bold padTS taola_sub_title" style="color:#222;">참가 신청하고자 하시는 날짜와 세션을 선택해주세요.</p>
    </div>

    <hr style="border-top:1px solid #e3e3e3;">

    <div class="widM">
      <div class="clearfix">
        <div class="amway-theme">
            <div v-for="item in sessionList" :key="item.idx" class="radio-wrapper NCACroa_cont03_radio NCACroa_radioBtn">

              <label class="amw-radio-wrap radio-label focus disBl" style="margin-bottom: 20px;">
                
                <input type="radio" name="radio-7" class="amw-global-radio"
                  v-model="selectedSessionId"
                  :value="item.session_id"
                  :disabled="item.remainSeat <= 0">

                <span class="amw-radio-overlay"></span> 
                <span v-if="item.remainSeat > 0" class="amw-label-radio-text">
                  &lt;{{item.event_title}}&gt;
                  <b>{{item.session_name}}</b>
                    {{item.session_time}}&nbsp;&nbsp;
                    <br class="moOnly"/>
                    <!-- <em v-if="item.remainSeat > 0"> -->
                      <!-- (잔여 수량 : {{item.remainSeat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}세트) -->
                    <!-- </em> -->
                    <!-- <em v-else> -->
                      <!-- (잔여 수량 : {{item.remainSeat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}세트) -->
                    <!-- </em> -->
                </span>
                
                <span v-else class="amw-label-radio-text" style="color: rgb(215, 211, 211);">
                  &lt;{{item.event_title}}&gt;
                  <b style="color: rgb(215, 211, 211);">{{item.session_name}}</b>
                  {{item.session_time}}&nbsp;&nbsp;
                  <br class="moOnly"/>
                </span>
              </label>
            </div>
          </div>
      </div>
    </div>

    <hr style="border-top:1px solid #e3e3e3; margin: 15px 0 10px;">

    <p class="fntE txtL bold widM mo_padTS" style="color:#d91734;">* 1세트 당 &lt;타올라존&gt; 티켓 2매를 제공해 드립니다.</p>

    <div class="marTML mo_marTML2" style="background:#f7f7f7;">
        <div class="widM padTML padBML">
          <div class="fntH6 fntL bold taola_sub_title" style="color:#333;">알아 두세요!</div>

          <hr style="border-top:1px solid #e3e3e3;">
          
          <ul class="taola_notice fntP">
            <!-- S : 20230724 우주라이드 타올라존 티켓 신청 페이지 수정 -->
            <li>ABO 번호당 1세션 (한가지 세션) 신청 가능합니다.</li>
            <li>1세션 신청 시 &lt;타올라존&gt; 2매가 제공됩니다. (2매 모두 동일 세션으로 제공)</li>
            <li>여러 개의 프로필로 150KM 미션을 달성했더라도 ABO 번호 1개당 티켓 최대 2매 선착순 신청이 가능합니다.</li>
            <li>타올라존 체험은 오전 9시 30분~오후 8시까지 오전(09:30~13:00) / 오후(13:00~17:00) / 저녁(17:00~20:00) 3개 타임으로 나뉘어 운영됩니다. 단, 머슬핀 인정식이 진행되는 14:00-14:30에는 체험이 제한됩니다.</li>
            <li>신청 마감된 세션은 추가로 신청하실 수 없습니다.</li>
            <li>신청하신 세션의 변경을 원하실 경우 취소 후 재신청하셔야 합니다. 취소 후 재신청 시 신청하고자 하는 세션이 마감되었을 경우 신청이 불가하며, 취소된 세션의 신청 내역 또한 복구가 불가능합니다.</li>
            <li>세션 변경은 8월 10일 (목) 자정까지만 가능하며, 마감후에는 취소가 불가합니다.</li>
            <li>우주라이드 현장에서 ABO 번호 확인 후 티켓으로 교환해 드립니다.</li>
            <!-- E : 20230724 우주라이드 타올라존 티켓 신청 페이지 수정 -->
          </ul>
        </div>
    </div>

    <div class="widM txtC marTML">
      <!--모든 필수 값 입력 시에만 신청하기 활성화 -->
      <button @click="reservation"
       id="addToCart"
       class="bt-akl-blue large NCACroa_submit" 
       :disabled="this.selectedSessionId == null ||
        this.aboInfo.user_id == null ||
        this.aboInfo.user_name == null ">
       신청하기
      </button>
    </div>
    <div class="padM disIb">
      <Loading v-show="this.isLoading"></Loading>
    </div>
    <!-- //세션 선택-->
  </div>
</div>
</div><!-- //.bod-view-txt --></div><!-- //.akl -->

</template>

<script>

import axios from 'axios'
import { TAOLA , SET_RESERVATION_INFO} from '@/store/actions/taola'
import Loading from '../component/Loading.vue'

export default {
  name: 'wouldu-event',

  data () {
    return {
      aboInfo: Object,  // Abo Info
      sessionList : [], // 세션리스트
      selectedSessionId : null, // 세션아이디,
      existReservation : null,  // 사용자 예약정보확인
      isLoading : false,
      eventPeriod : null    // 이벤트 참여기간
    }
  },
  components : {
    Loading : Loading
  },

  methods : {
    async initView () {
      this.aboInfo = {user_id : '', user_name : ''}
      await this.checkLogin()
    },
    // Hybris 로그인
    async checkLogin () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          const b64UserId = atob(response.data.customerUid)
          this.aboInfo.user_id = b64UserId
          this.aboInfo.user_name = response.data.name
          // 응모대상자 조회
          if(this.aboInfo.user_id != null && this.aboInfo.user_name)
            this.frontValidAbo()
        }
      }).catch(ex => {
        alert('브라우저를 닫고 다시 접속해주세요.')
        console.log("[Hybris Login Error]" , ex)
      })
    },
    
    // 로그인 성공 후 응모대상자를 조회한다.
    async frontValidAbo() {
      await axios.post(process.env.AWS_GATEWAY_URL_V2+'/wouldUride-event/valid/abo',
      {
        user_id : this.aboInfo.user_id,
        eventTime : this.currentTime(),
        state   : ''
      })
      .then(response => {
        console.log("User Response " , response)
        if(response.data.abo === null ) {
          // 8/3 오전 10시 이전 페이지 접속 시
          // alert 문구 띄우고 amway.co.kr 메인페이지로 이동 
          alert('참가 대상자가 아닙니다.')
          window.location.href = process.env.AMWAY_ROOT_URL
          return false
          // 8/10일 이후 페이지 접속 시 예외처리
          // 1. 이벤트 종료 시점으로부터 예약정보가 있는 회원은 예약페이지로 이동된다.
        }else if (response.data.event_day.result === 'N' && response.data.abo.reservationYn === 'Y') {
          this.eventPeriod = response.data.event_day.result
          this.frontUserReservationConfirm()
          // 2. 예약정보가 없는 회원은 alert 표시 후 Amway Main 페이지로이동.
        }else if (response.data.event_day.result === 'N' && response.data.abo.reservationYn === 'N') {
          alert('준비수량이 모두 소진되어 <타올라존> 신청이 마감되었습니다.')
          window.location.href = process.env.AMWAY_ROOT_URL
          return false;
          // 8/3 오전 10시 이전 페이지 접속시 예외처리
        }else if (response.data.event_day.result === 'N') {
          alert('참여 기간이 아닙니다.')
          
          // window.location.href = process.env.AMWAY_ROOT_URL
          return false;
          // 유효회원이고 예약정보가 없을경우
        }else if (response.data.abo.isValid === 'Y' && response.data.abo.reservationYn === 'N' || response.data.abo.reservationYn === null) {
          // 세션리스트 조회
          this.existReservation = response.data.abo.reservationYn
          this.frontSessionList()
          // 예약정보가 존재 할 경우
        }else if (response.data.abo.reservationYn === 'Y') {
          // 예약정보조회
          this.frontUserReservationConfirm()
        }
      })
      .catch(error =>{
        console.log("[WouldUrideTaolaEvent Server Error]", error)
      })
    },
    // 응모대상자일 경우 세션리스트를 조회한다.
    async frontSessionList() {
      await axios.post(process.env.AWS_GATEWAY_URL_V2+'/wouldUride-event/sessions')
      .then(response =>{
        this.sessionList = response.data
      })
      .catch(error =>{
        console.log("[WouldUrideTaolaEvent Server Error]", error)
      })
    },
    // 예약정보저장
    reservation () {
      // 선택한 세션아이디 데이터가져오기
      const selectedSession = this.sessionList.find(item => item.session_id === this.selectedSessionId);
      // 데이터 세팅
      const data = {
        'user_name' : this.aboInfo.user_name,
        'user_id' : this.aboInfo.user_id,
        'session_id' : this.selectedSessionId,
        'state' : 'apply',
        'event' : {
          title : selectedSession.event_title,
          session_name : selectedSession.session_name,
          session_time : selectedSession.session_time
        }
      }
      if(data != null) {
        this.isLoading = true
        this.frontReservationInsert(data)
      }
    },
    // 예약정보를 저장한다.
    async frontReservationInsert(data) {
      await axios.post(process.env.AWS_GATEWAY_URL_V2+'/wouldUride-event/reservation',data)
      .then(response => {
        if(response.data.status == 200) {
          this.isLoading = false
          this.$store.commit(`${TAOLA}/${SET_RESERVATION_INFO}`, data);
          this.$router.push('/wouldu-complete')
        }else {
          // 1.남은잔여석이 1개만 남았을때 동시 트랜잭션 발생 시 alert 표시.
          alert(response.data.message)
          this.$router.go(0)
          return false;
        }
      })
      .catch(error =>{
        console.log("Error >>>>> " , error)
      })
    },
    // 예약정보를 조회한다.
    async frontUserReservationConfirm() {
      await axios.post(process.env.AWS_GATEWAY_URL_V2+'/wouldUride-event/valid/abo',
      {
        user_id : this.aboInfo.user_id,
        eventTime : this.currentTime(),
        state : 'confirm'
      })
      .then(response =>{
        let confirmInfo = null
        if(response.data.abo != null){
          confirmInfo = {
            'user_name' : response.data.abo.user_name,
            'user_id' : response.data.abo.user_id,
            'session_id' : response.data.abo.session_id,
            'event' : {
              title : response.data.abo.event_title,
              session_name : response.data.abo.session_name,
              session_time : response.data.abo.session_time,
              eventPeriod : this.eventPeriod
            }
          }
          // 예약정보가 있을경우 신청완료 화면으로 이동.
          this.$store.commit(`${TAOLA}/${SET_RESERVATION_INFO}`, confirmInfo);
          this.$router.replace('/wouldu-complete');
        }
      })
      .catch(error =>{
        console.log("Error >>>" , error)
      })
    },
    // 현재날짜를 구한다.
    currentTime () {
      let now = new Date();
      let year = now.getFullYear();
      let month = ('0' + (now.getMonth() + 1)).slice(-2);
      let day = ('0' + now.getDate()).slice(-2);
      let hours = ('0' + now.getHours()).slice(-2);
      let minutes = ('0' + now.getMinutes()).slice(-2);
      let seconds = ('0' + now.getSeconds()).slice(-2);
      let formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
      return formattedDate
    }
  },
  mounted () {
    this.currentTime()
    this.initView()
  }  
}
</script>

<style scoped>

@import '../font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css');
@import '../css/style.css';
</style>


// WEBPACK FOOTER //
// src/views/taola/wouldUride/WouldUrideTaolaEvent.vue